module.exports = "<div class=\"search-menu-input {{ theme | themeClass }}\"> <div class=\"input-stage clearfix\"> <div class=drop-menu-wrap> <drop-menu theme=s-drop-menu :option-items=menuData v-ref:sourcemenukey :query-name=queryName> </drop-menu> </div> <div class=\"input-wrap clearfix\"> <div class=icon-warp> <icon name=search></icon> </div> <input-box :placeholder=placeholder v-ref:sourcemenuval> </input-box> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/common/components/common/search-menu-input/search-menu-input.tpl
// module id = 956
// module chunks = 2